import { render } from "./CenteredFormLayout.vue?vue&type=template&id=6fabcb8d&scoped=true"
import script from "./CenteredFormLayout.vue?vue&type=script&lang=js"
export * from "./CenteredFormLayout.vue?vue&type=script&lang=js"

import "./CenteredFormLayout.vue?vue&type=style&index=0&id=6fabcb8d&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fabcb8d"]])

export default __exports__